import {useAppSelector} from 'hooks';
import {safeToFixed} from 'utils/helper';

export const useExpressWeightLimit = () => {
  const {basket} = useAppSelector((state) => state.basket);
  const totalWeight = +safeToFixed(basket?.totalOrderWeightKg);
  const threshold = basket?.expressWeightKgLimit || Infinity;
  const capacityPercent = (totalWeight * 100) / threshold;

  return {
    capacityPercent: capacityPercent > 100 ? 100 : capacityPercent,
    isWithinThreshold: capacityPercent <= 100,
    totalWeight,
    threshold
  };
};
